import 'bootstrap/dist/css/bootstrap.css';
//import 'bootstrap/dist/css/bootstrap-theme.css';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { createBrowserHistory } from 'history';
import { msalConfig } from './components/auth/AzureADProvider';
import App from './App';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

const msalInstance = new PublicClientApplication(msalConfig);

const rootElement = document.getElementById('root');

ReactDOM.render(
    <div>
        <MsalProvider instance={msalInstance} >
            <App />
        </MsalProvider>
    </div>
    ,
    rootElement);
